import { reactive } from 'vue';

export const DEMO_STATUS = Object.freeze({
  OFF: 'off',
  READY: 'ready',
});

export const demoState = reactive({
  status: DEMO_STATUS.OFF,
});

export function setDemoStatus(status) {
  const next =
    status === DEMO_STATUS.READY || status === 'activating' || status === true
      ? DEMO_STATUS.READY
      : DEMO_STATUS.OFF;
  demoState.status = next;
}

export default {
  namespaced: true,
  state: () => demoState,
  mutations: {
    SET_STATUS(state, status) {
      const next =
        status === DEMO_STATUS.READY || status === 'activating' || status === true
          ? DEMO_STATUS.READY
          : DEMO_STATUS.OFF;
      state.status = next;
      demoState.status = next;
    },
  },
  getters: {
    status: (state) => state.status,
    isDemoMode: (state) => state.status !== DEMO_STATUS.OFF,
    isReady: (state) => state.status === DEMO_STATUS.READY,
  },
};
